import Image from "next/image";
import { useEffect, useState } from "react";
import StarRatings from "react-star-ratings";

export default function AppRatingSection({ marginTop, googlePlayData }) {
  const reviews = [
    {
      name: 'Farida Soliman',
      review: 'Its a very useful application , i recommend installing it, it offers many opportunities and you can find a job near to you and there are many options to choose from .'
    },
    {
      name: 'Bunny',
      review: 'Amazing app. I got 2 job interviews from Skatch '
    },
    {
      name: 'Mansargun',
      review: 'Best app to finds jobs'
    },
    {
      name: 'Amira Hassan',
      review: 'Really an excellent program and its content is amazing'
    }
  ];

  return (
    <section className="d-none d-md-flex" style={{ marginTop, height: '472px', backgroundImage: 'url("/images/background-rating.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', paddingInline: '100px', justifyContent: 'space-between' }}>
      <div style={{ width: '389px', paddingTop: '55px' }}>
        <h3 style={{ fontWeight: 700, fontSize: '32px', lineHeight: '48px', color: 'black' }}>
          Join over <span style={{ color: '#FF7D3D' }}>{googlePlayData?.downloads}</span> happy users on Skatch App
        </h3>

        <div style={{ marginTop: '-11px', display: 'flex', alignItems: 'center', gap: '-6.5px', fontWeight: 600, fontSize: '30px', lineHeight: '48px', color: '#4E4E4E' }}>
          <Image src='/images/google-play.png' alt='google play logo' width={215.65} height={113} />
          Reviews
        </div>

        <div style={{ marginTop: '-17px', paddingInlineStart: '16px', display: "flex", alignItems: 'center', gap: '4.5px' }}>
          <div style={{ fontWeight: 600, fontSize: '31px', lineHeight: '26px', color: 'black' }}>
            {googlePlayData?.rating}
          </div>

          <div />

          {googlePlayData ?
            <StarRatings
              rating={googlePlayData?.rating}
              starRatedColor="#FFB400"
              starEmptyColor="white"
              starDimension="32.5px"
              starSpacing="5px"
            />
            : null
          }

          <div style={{ fontWeight: 600, fontSize: '13.5px', lineHeight: '21px', color: '#4E4E4E' }}>
            ({googlePlayData?.noOfRatings})
          </div>
        </div>
      </div>

      <div className="connect" style={{ margin: 0, width: '820px', backgroundColor: 'transparent', backgroundImage: 'url("/images/background-reviews.svg")', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', padding: 0 }}>
        <div className="slider-container" style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          <div className="slider" style={{ width: '540px', height: '250px' }}>
            {reviews.map((rev, index) => (
              <div key={index} className="slide" data-slide={index + 1} style={{ width: '100%' }}>
                <div className="testimonial" style={{ margin: 0, borderRadius: '7px', minHeight: '228px' }}>
                  <div className="pic" style={{ width: '65px', height: '65px', borderRadius: '50%', backgroundColor: '#004D40', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '40px', color: 'white' }}>
                    {rev.name[0]}
                  </div>
                  <div style={{ position: 'absolute', insetInlineStart: '150px', top: '16px' }}>
                    <Image src='/images/icon/5-stars.svg' alt='5 stars icon' width={100} height={20} />
                  </div>
                  <p className="description" style={{ marginBlock: '22px 0' }}>
                    {rev.review}
                  </p>
                  <h5 className="name" style={{ margin: 0, position: 'absolute', bottom: '25px' }}>{rev.name}</h5>
                </div>
              </div>
            ))}
          </div>

          <div className="slide-toggle-container" style={{ position: 'absolute', insetInlineEnd: 0, height: '100%', zIndex: 100 }}>
            <div id="back" className="slide-toggle disabled">
              <img
                alt="get-image"
                src="/images/job/XMLID_gre.svg"
                className="img-fluid webIcon"
              />
              <img
                alt="get-image"
                src="/images/job/XMLID_224_.svg"
                className="img-fluid mbIcon"
              />
            </div>
            <div id="forvard" className="slide-toggle">
              <img
                alt="get-image"
                src="/images/job/XMLID_orange_.svg"
                className="img-fluid webIcon"
              />
              <img
                alt="get-image"
                src="/images/job/XMLID-1.svg"
                className="img-fluid mbIcon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}